const COMBINATION_PROMOTION_TYPE = 5

const normalizeProductId = (value) => {
  const number = Number(value)
  return Number.isFinite(number) && number > 0 ? number : null
}

/**
 * @description 读取当前商品真实配置的活动商品图，不使用商品目录图回退值。
 * @param {Object|null|undefined} detail
 * @param {string|number} prodId
 * @returns {string}
 */
export function resolvePromotionDetailProductImage(detail, prodId) {
  if (!detail || typeof detail !== 'object') return ''

  const normalizedProdId = normalizeProductId(prodId)
  if (!normalizedProdId) return ''

  const pictureOf = (product) => String(product?.promotionPicture || '').trim()
  const matchesProduct = (product) => normalizeProductId(product?.prodId) === normalizedProdId

  const directPicture = pictureOf((detail.products || []).find(matchesProduct))
  if (directPicture) return directPicture

  const comboProducts = [detail.combo?.mainProduct, ...(detail.combo?.comboProducts || [])].filter(
    Boolean
  )
  const comboPicture = pictureOf(comboProducts.find(matchesProduct))
  if (comboPicture) return comboPicture

  const activityType = Number(detail.activityType ?? detail.promotionType)
  if (activityType === COMBINATION_PROMOTION_TYPE) {
    return String(detail.promotionPicture || '').trim()
  }

  return ''
}
